export const FEATURE_FLAG_FACTSET_KONG_LIMA = 'factset-kong-lima'
